<template>
  <div class="col-4 mb-3">
    <label>{{ labelText }}</label>

    <numerictextbox
      type="number"
      :name="fieldName"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    ></numerictextbox>
  </div>
</template>
<script>
export default {
  name: "NumberInput",
  props: ["placeholder", "labelText", "fieldName", "value"],
};
</script>
